import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import ChatInputConfirm from '../ChatInputConfirm';
import ChatHistoryDetail from './ChatHistoryDetail'
import ModalWrapper from 'utils/ModalWrapper';
import { LINE_MESSAGE_TYPE, CHAT_TYPE, NON_FINANCIAL_MESSAGE_TYPE } from 'const';
import { getAcceptanceStatus } from 'utils/AcceptanceStatus';
import styles from 'styles/admin-detail.module.scss';
import { convertDateSeparator, convertDateSeparatorOrHyphen } from 'utils/utils';

const useStyles = makeStyles(() => ({
  root: { marginBottom: 5 },
}));

export const toMessageTypeLabel = (chatType, messageType) => {
  if (!chatType) {
    throw new Error("chatType must be filled")
  }
  if (chatType === 1) {
    return LINE_MESSAGE_TYPE[messageType] ? LINE_MESSAGE_TYPE[messageType] : "不明"
  } else {
    return NON_FINANCIAL_MESSAGE_TYPE[messageType] ? NON_FINANCIAL_MESSAGE_TYPE[messageType] : "不明"
  }
}

export const toChatTypeLabel = (chatType) => {
  if (!chatType) {
    throw new Error("chatType must be filled")
  }
  return CHAT_TYPE[chatType] ? CHAT_TYPE[chatType] : "不明"
}

export const toChatContent = (chatHistory) => {
  if ([1, 2].includes(chatHistory.type)) {
    return getAcceptanceStatus(chatHistory)
  }
  if (chatHistory.type === 4 && chatHistory.acceptanceStatus === 2) {
    return "了解済み"
  } else if (chatHistory.acceptanceStatus === 2) {
    return "回答済み"
  } else if (chatHistory.type === 4 && chatHistory.acceptanceStatus === 4) {
    return "確認事項あり"
  } else if (chatHistory.urlInvalidFlg || chatHistory.hasPassed14DaysSincePublishedUrl) {
    return 'URL無効';
  } else if (chatHistory.acceptanceStatus === 1) {
    return "回答待ち"
  }
  return "想定外のデータ状態"
}
const ChatHistory = (props) => {
  const { detailData } = props;

  const chatHistories = detailData.chatHistories;
  const classes = useStyles();

  const [confirmModal, setConfirmModal] = useState(Boolean(false));
  const [showsDetailModal, setShowsDetailModal] = useState(Boolean(false));

  const openModal = () => {
    setConfirmModal(Boolean(true));
  };
  const closeModal = () => {
    setConfirmModal(Boolean(false));
  };

  const [chatHistoryDetail, setChatHistoryDetail] = useState(null);

  const onClickDetail = (chatHistory) => {
    // メールの場合は詳細モーダルを表示しない
    if (chatHistory?.type === 3) {
      return;
    }
    setChatHistoryDetail(chatHistory);
    if (chatHistory?.type === 1) {
      // 金銭異動の承諾依頼の場合は専用のモーダルを表示
      openModal();
    } else {
      setShowsDetailModal(true)
    }
  };

  return (
    <>
      <CardContent className={classes.content}>
        <div className={classes.inner}>
          <Table>
            <colgroup>
              <col width='12%' />
              <col width='12%' />
              <col width='12%' />
              <col width='40%' />
              <col width='12%' />
              <col width='12%' />
            </colgroup>
            <TableHead>
              <TableRow>
                <TableCell>送信日時</TableCell>
                <TableCell>チャット種別</TableCell>
                <TableCell>回答フォーム種別</TableCell>
                <TableCell>回答フォームメッセージ</TableCell>
                <TableCell>回答日時</TableCell>
                <TableCell>回答結果</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {chatHistories?.length > 0 &&
                chatHistories.map((chatHistory) => (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={chatHistory?.notificationId}
                  >
                    <TableCell onClick={() => onClickDetail(chatHistory)}>
                      {convertDateSeparator(chatHistory?.sendLineAt)}
                    </TableCell>
                    <TableCell onClick={() => onClickDetail(chatHistory)}>
                      {toMessageTypeLabel(chatHistory?.type, chatHistory?.messageType)}
                    </TableCell>
                    <TableCell onClick={() => onClickDetail(chatHistory)}>
                      {toChatTypeLabel(chatHistory?.type)}
                    </TableCell>
                    <TableCell onClick={() => onClickDetail(chatHistory)}>
                      <p className={styles.formMessage}>
                        {chatHistory?.type === 2 ?
                          chatHistory?.freeMessage.split('\n').map(row => {
                            return (
                              <>
                                {row}
                                <br />
                              </>
                            )
                          })
                          : chatHistory?.message.split('\n').map(row => {
                            return (
                              <>
                                {row}
                                <br />
                              </>
                            )
                          })
                        }
                      </p>
                    </TableCell>
                    <TableCell onClick={() => onClickDetail(chatHistory)}>
                      {convertDateSeparatorOrHyphen(chatHistory?.answeredAt)}
                    </TableCell>
                    <TableCell onClick={() => onClickDetail(chatHistory)}>
                      {toChatContent(chatHistory)}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
      <ModalWrapper
        open={confirmModal}
        handleClose={closeModal}
        scroll={true}
        content={
          <ChatInputConfirm
            chatHistory={chatHistoryDetail}
            detailData={detailData}
            closeModal={closeModal}
            canSend={false}
          />
        }
      />
      <ModalWrapper
        open={showsDetailModal}
        handleClose={() => setShowsDetailModal(false)}
        scroll={true}
        content={
          <ChatHistoryDetail
            chatHistory={chatHistoryDetail}
            detailData={detailData}
            closeModal={() => setShowsDetailModal(false)}
          />
        }
      />
    </>
  );
};

export default ChatHistory;
